import {
  UserAvatar,
  RouterSelectMenu,
  PageLayout,
  PageLayoutSidebar,
  PageLayoutTabs,
  PageLayoutQueryTabs,
  PageProvider,
  PageMain,
  PageBody,
  PageHeader,
  SectionHeader,
  AccessDenied,
  Separator,
  DataList,
  DataListItem,
  DataListItemLeading,
  DataListItemTitle,
  DataListItemMeta,
  DataListItemActions,
  DataListItemAction,
  DataListItemDescription,
  DataListItemIcon,
  SwitchTiny,
  SwitchToggleBox,
  ContentRowTwoColumns,
  GenericButton,
  GenericButtonProvider,
  ConfirmDialog,
  ButtonDropdown,
  FormSectionHeader,
  FormSectionContent,
  FormTitleSeparator,
  SelectMenuItem,
  RadioGroup,
  RadioGroupItem,
  AvatarIcon,
  AvatarTwoLine,
  LinkPhone,
  LinkEmail,
  GatKeyboardShortcuts,
  GatKeyboardShortcutsWithTooltip,
  GatKeyboardShortcutHint,
  ModalSectionHeader,
  ModalSection
} from '@gat-ship/shared'
import {
  GatDialog,
  GatButton,
  GatDropdownMenu,
  GatSwitch,
  Spinner,
  GatTextEdit,
  GatTextAreaEdit,
  GatDateEdit,
  GatIcon,
  GatTab,
  GatCombobox,
  GatFlag,
  GatPhoneEdit,
  GatForm,
  GatAlertDialog,
  AppDrawer,
  Modal,
  ModalContent,
  TransitionFade,
  GatLink,
  GatCheckbox,
  CollapsibleGroup,
  LoadingSpinner,
  GatNumEdit,
  TooltipHint,
  FieldStack,
  FieldLabel,
  FieldReadonly,
  FieldRemovable,
  FieldStackLabel
} from '@gat-ship/vue-components'
import { Badge } from '@gat-ship/vue-components/badge'
import {
  Card,
  CardContent,
  CardContentSplit,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@gat-ship/vue-components/card'
import {
  DataTable,
  DataTableColumnHeader,
  DataTablePagination,
  DataTableViewOptions,
  DataTableCellPopover
} from '@gat-ship/vue-components/data-table'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger
} from '@gat-ship/vue-components/dropdown-menu'
import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from '@gat-ship/vue-components/popover'
import { Skeleton } from '@gat-ship/vue-components/skeleton'

import type { App } from 'vue'

export function registerGlobalComponents(app: App) {
  const globalComponents = {
    PageLayout,
    PageLayoutSidebar,
    PageLayoutTabs,
    PageLayoutQueryTabs,
    PageProvider,
    PageMain,
    PageBody,
    PageHeader,
    SectionHeader,
    // AppLayoutPresetSubNav,
    // AppLayoutPresetTabs,
    // AppLayoutPresetQueryTabs,
    // AppLayoutPageHeader,
    // AppLayoutSectionHeader,
    // AppLayoutMain,
    // AppLayoutBody,
    AccessDenied,
    Popover,
    PopoverTrigger,
    PopoverContent,
    Badge,
    Card,
    CardContent,
    CardContentSplit,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
    GatDialog,
    GatButton,
    GatDropdownMenu,
    GatSwitch,
    Spinner,
    GatTextEdit,
    GatTextAreaEdit,
    GatDateEdit,
    GatIcon,
    GatTab,
    GatCombobox,
    GatFlag,
    GatPhoneEdit,
    GatForm,
    Separator,
    DataList,
    DataListItem,
    DataListItemLeading,
    DataListItemTitle,
    DataListItemMeta,
    DataListItemActions,
    DataListItemAction,
    DataListItemDescription,
    DataListItemIcon,
    AppDrawer,
    Modal,
    ModalContent,
    TransitionFade,
    GatAlertDialog,
    DataTable,
    DataTableColumnHeader,
    DataTablePagination,
    DataTableViewOptions,
    Skeleton,
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuSeparator,
    DropdownMenuShortcut,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
    GatLink,
    DataTableCellPopover,
    GatCheckbox,
    UserAvatar,
    CollapsibleGroup,
    RouterSelectMenu,
    SwitchTiny,
    SwitchToggleBox,
    ContentRowTwoColumns,
    GenericButton,
    GenericButtonProvider,
    ConfirmDialog,
    LoadingSpinner,
    ButtonDropdown,
    FormSectionHeader,
    FormSectionContent,
    FormTitleSeparator,
    TooltipHint,
    SelectMenuItem,
    RadioGroup,
    RadioGroupItem,
    AvatarIcon,
    AvatarTwoLine,
    LinkPhone,
    LinkEmail,
    GatNumEdit,
    GatKeyboardShortcuts,
    GatKeyboardShortcutsWithTooltip,
    GatKeyboardShortcutHint,
    FieldStack,
    FieldLabel,
    ModalSectionHeader,
    ModalSection,
    FieldReadonly,
    FieldRemovable,
    FieldStackLabel
  }
  Object.entries(globalComponents).forEach(([name, component]) => {
    app.component(name, component as Component)
  })
}
